import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nmviajes-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
}
